/**
 * Footer behavior:
 *  1. "Cookie preferences" button → OneTrust / Klaro / Shopify customer-privacy.
 *  2. Klaviyo newsletter watchdog → promotes the Klaviyo embed to visible only
 *     once it actually renders a <form>; otherwise the native Shopify-form
 *     backstop stays as the working signup.
 */

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-action="open-cookie-prefs"]');
  if (!btn) return;

  if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
    window.OneTrust.ToggleInfoDisplay();
    return;
  }
  if (window.klaro && typeof window.klaro.show === 'function') {
    window.klaro.show();
    return;
  }
  if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPrivacyBanner === 'function') {
    window.Shopify.customerPrivacy.showPrivacyBanner();
    return;
  }
  console.info('[site-footer] No consent SDK detected.');
});

// Klaviyo watchdog. CSS hides the .klaviyo-form-* div by default. Promote it
// only after Klaviyo actually renders a <form> or <iframe> inside it. Give up
// after 4 s — at that point the native form stays as the working backstop.
(() => {
  const wrap = document.querySelector('[data-klaviyo-fallback][data-klaviyo-id]');
  if (!wrap) return;
  const slot = wrap.querySelector('[class*="klaviyo-form-"]');
  if (!slot) return;

  const isHydrated = () => !!slot.querySelector('form, iframe, [class*="kl_form_"]');
  if (isHydrated()) {
    wrap.classList.add('is-klaviyo-loaded');
    return;
  }

  const observer = new MutationObserver(() => {
    if (isHydrated()) {
      wrap.classList.add('is-klaviyo-loaded');
      observer.disconnect();
      clearTimeout(timer);
    }
  });
  observer.observe(slot, { childList: true, subtree: true });

  const timer = setTimeout(() => observer.disconnect(), 4000);
})();
